import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import tryToPlayVideo from 'utils/tryToPlayVideo';
import { pause, loadImage } from 'helpers';
import { slotMachineIcons, slotMachineIconIds, ninjiPoses } from 'helpers/downWorldData.js';

import s from 'components/bolt/downWorld/slotMachineWinEffects/slotMachineWinEffects.sss';

const { iceFlower, coin, poisonMushroom, superStar, fireFlower, powerUpMushroom, cherries, ninji, boomerangFlower, yoshiEgg, superBell } = slotMachineIconIds;

export default class SlotMachineWinEffects extends Component {
	constructor(props) {
		super(props);
		this.state = {
			effectActive: false
		};
		this.onEffectEnded = this.onEffectEnded.bind(this);
		this.setAnimEndTimer = this.setAnimEndTimer.bind(this);
		this.superBellAnimStart = this.superBellAnimStart.bind(this);
		this.superBellAnimComplete = this.superBellAnimComplete.bind(this);
	}

	async componentDidMount() {
		const { imageRoot } = this.props;
		await Promise.all(ninjiPoses.map(async pose => await loadImage(`${imageRoot}/down/effects/${pose}.webp`)));
		this.ninjiScreens = [
			this.renderNinjis(0),
			this.renderNinjis(1)
		];
	}

	async componentDidUpdate(prevProps) {
		const { winningIcon, client } = this.props;
		if (winningIcon === prevProps.winningIcon) return;

		await pause(800);
		if (winningIcon === iceFlower) {
			this.setState({ effectActive: true });
			this.$iceVideoTop.currentTime = 0;
			this.$iceVideoBottom.currentTime = 0;
			tryToPlayVideo(this.$iceVideoTop).catch(() => this.setAnimEndTimer({ pauseTime: 8000 }));
			tryToPlayVideo(this.$iceVideoBottom).catch(() => this.setAnimEndTimer({ pauseTime: 8000 }));
		}
		if (winningIcon === coin) {
			this.setState({ effectActive: true });
			this.$coinStackVideo.currentTime = 0;
			Store.emit('PLAY_SOUND', 'coin');
			tryToPlayVideo(this.$coinStackVideo).catch(() => this.setAnimEndTimer({ pauseTime: 1000 }));
		}
		if (winningIcon === poisonMushroom) {
			this.setAnimEndTimer({ pauseTime: 4000 });
		}
		if (winningIcon === superStar) {
			this.setState({ effectActive: true });
			this.pauseMusic();
			Store.emit('PLAY_SOUND', 'slotMachineSuperStar');
			this.setAnimEndTimer({ pauseTime: 2800 });
		}
		if (winningIcon === fireFlower) {
			this.setState({ effectActive: true });
			this.$fireTopVideo.currentTime = 0;
			this.$fireBottomVideo.currentTime = 0;
			this.$fireLeftVideo.currentTime = 0;
			this.$fireRightVideo.currentTime = 0;
			tryToPlayVideo(this.$fireTopVideo).catch(() => this.setAnimEndTimer({ pauseTime: 7000 }));
			tryToPlayVideo(this.$fireBottomVideo).catch(() => this.setAnimEndTimer({ pauseTime: 7000 }));
			tryToPlayVideo(this.$fireLeftVideo).catch(() => this.setAnimEndTimer({ pauseTime: 7000 }));
			tryToPlayVideo(this.$fireRightVideo).catch(() => this.setAnimEndTimer({ pauseTime: 7000 }));
		}
		if (winningIcon === powerUpMushroom) {
			this.setState({ effectActive: true });
			Store.emit('MUSHROOMED_CURSOR');
			Store.emit('PLAY_SOUND', 'slotMachinePowerUpMushroom');
			this.setAnimEndTimer({ pauseTime: 3100 });
		}
		if (winningIcon === cherries) {
			this.setState({ effectActive: true });
			Store.emit('DUPLICATED_CURSOR');
			this.setAnimEndTimer({ pauseTime: 2600 });
		}
		if (winningIcon === ninji) {
			this.setState({ effectActive: true });
			this.setAnimEndTimer({ pauseTime: 10000 });
		}
		if (winningIcon === boomerangFlower) {
			this.setState({ effectActive: true });
			const isDesktop = client?.isDesktopWidth;
			if (isDesktop) {
				Store.emit('ROB_UPDATE', 'boomerang');
			}
			this.setAnimEndTimer({ pauseTime: isDesktop ? 7000 : 2600 });
		}
		if (winningIcon === yoshiEgg) {
			this.setState({ effectActive: true });
			this.$yoshiEggVideo.currentTime = 0;
			this.pauseMusic();
			tryToPlayVideo(this.$yoshiEggVideo).catch(() => this.setAnimEndTimer({ pauseTime: 1000 }));
		}
		if (winningIcon === superBell) {
			this.setState({ effectActive: true });
			this.$superBellVideo.currentTime = 0;
			Store.emit('PLAY_SOUND', 'slotMachineSuperBell');
			tryToPlayVideo(this.$superBellVideo).catch(() => this.setAnimEndTimer({ pauseTime: 9000 }));
			this.superBellAnimStart();
		}
	}

	componentWillUnmount() {
		this.onEffectEnded();
		this.forceEndEffectTimer && clearTimeout(this.forceEndEffectTimer);
	}

	onEffectEnded() {
		this.setState({ effectActive: false });
		this.resumeMusic();
		Store.emit('SLOT_MACHINE_ANIM_COMPLETE');
		if (this.props.winningIcon === superBell) {
			Store.emit('SLOT_MACHINE_SHOW_WINNING_ICON');
			this.superBellAnimComplete();
		}
	}

	setAnimEndTimer({ pauseTime }) {
		this.forceEndEffectTimer = setTimeout(this.onEffectEnded, pauseTime);
	}

	superBellAnimStart() {
		Store.emit('SLOT_MACHINE_HIDE_WINNING_ICON');
	}

	superBellAnimComplete() {
		Store.emit('SLOT_MACHINE_SHOW_WINNING_ICON');
		this.props.setEasterEgg(0);
	}

	pauseMusic() {
		Store.emit('PAUSE_MUSIC');
		this.downWorldMusicPaused = true;
	}

	resumeMusic() {
		if (this.downWorldMusicPaused) {
			Store.emit('RESUME_MUSIC');
			this.downWorldMusicPaused = false;
		}
	}

	renderNinjis(screenIndex) {
		const { imageRoot } = this.props;
		return new Array(4).fill('row').map((row, rowIndex) => {
			return (
				<div class={s.ninjiRow} key={`screen-${screenIndex}-ninji-row-${rowIndex}`}>
					{new Array(4).fill('ninji').map((ninji, ninjiIndex) => {
						const isOddRow = rowIndex % 2 === 1;
						const randomNinji = ninjiPoses[Math.floor(Math.random() * ninjiPoses.length)];
						const translateYVal = Math.floor(Math.random() * 160) - 80; // random value between -80 and 80
						const rotateDurVal = Math.random() * 2 + 4; // random value between 4 and 6 seconds
						return (
							<div class={joinClasses(s.ninjiContainer, isOddRow && s.oddRow)} key={`screen-${screenIndex}-row-${rowIndex}-ninji-${ninjiIndex}`}>
								<img
									style={{ 
										translate: `0 ${translateYVal}%`,
										animationDuration: `${rotateDurVal}s`
									}}
									class={s.ninji}
									src={`${imageRoot}/down/effects/${randomNinji}.webp`}
								/>
							</div>
						);
					})}
				</div>
			);
		});
	}

	render({ imageRoot, videoRoot, winningIcon, client }) {
		const { effectActive } = this.state;

		const useMov = client?.isSafari || client?.isIOS;

		const showIceFlower = effectActive && winningIcon === iceFlower;
		const showCoin = effectActive && winningIcon === coin;
		const showSuperStar = effectActive && winningIcon === superStar;
		const showFireFlower = effectActive && winningIcon === fireFlower;
		const showNinji = effectActive && winningIcon === ninji;
		const showBoomerang = effectActive && winningIcon === boomerangFlower;
		const showYoshiEgg = effectActive && winningIcon === yoshiEgg;
		const showSuperBell = effectActive && winningIcon === superBell;

		const yoshiEggVideoSrc = `${videoRoot}/down/yoshi-egg-${client?.orientation === 'landscape' ? 'desktop' : 'mobile'}.${useMov ? 'mov' : 'webm'}`;

		return (
			<div class={s.container}>

				<div
					class={
						joinClasses(
							s.effect,
							showIceFlower && s.iceFlower,
							showSuperStar && s.superStar,
							showFireFlower && s.fireFlower,
						)}
				/>
				<div class={joinClasses(s.ninjiRain, showNinji && s.rainingNinji)}>
					<div class={s.ninjiRainScreen}>{this.ninjiScreens?.[0]}</div>
					<div class={s.ninjiRainScreen}>{this.ninjiScreens?.[1]}</div>
				</div>
				<div class={joinClasses(s.boomerangContainer, showBoomerang && s.throw)}>
					<img class={s.boomerang} src={`${imageRoot}/down/effects/boomerang.webp`} />
				</div>
				<video
					id="slot-ice-top-video"
					class={joinClasses(s.iceVideoTop, showIceFlower && s.active)}
					src={`${videoRoot}/down/frost-top.webm`}
					ref={$ref => this.$iceVideoTop = $ref}
					muted
					playsInline
					preload="auto"
					onEnded={this.onEffectEnded}
				/>
				<video
					id="slot-ice-bottom-video"
					class={joinClasses(s.iceVideoBottom, showIceFlower && s.active)}
					src={`${videoRoot}/down/frost-bottom.webm`}
					ref={$ref => this.$iceVideoBottom = $ref}
					muted
					playsInline
					preload="auto"
					onEnded={this.onEffectEnded}
				/>
				<video
					id="slot-coin-stack-video"
					class={joinClasses(s.coinStack, showCoin && s.active)}
					src={`${videoRoot}/down/coin-stack.${useMov ? 'mov' : 'webm'}`}
					ref={$ref => this.$coinStackVideo = $ref}
					muted
					playsInline
					preload="auto"
					onEnded={this.onEffectEnded}
				/>
				<video
					id="slot-fire-top-video"
					class={joinClasses(s.fireTop, showFireFlower && s.active)}
					src={`${videoRoot}/down/fire-top.webm`}
					ref={$ref => this.$fireTopVideo = $ref}
					muted
					playsInline
					preload="auto"
					onEnded={this.onEffectEnded}
				/>
				<video
					id="slot-fire-left-video"
					class={joinClasses(s.fireLeft, showFireFlower && s.active)}
					src={`${videoRoot}/down/fire-left.webm`}
					ref={$ref => this.$fireLeftVideo = $ref}
					muted
					playsInline
					preload="auto"
					onEnded={this.onEffectEnded}
				/>
				<video
					id="slot-fire-bottom-video"
					class={joinClasses(s.fireBottom, showFireFlower && s.active)}
					src={`${videoRoot}/down/fire-top.webm`}
					ref={$ref => this.$fireBottomVideo = $ref}
					muted
					playsInline
					preload="auto"
					onEnded={this.onEffectEnded}
				/>
				<video
					id="slot-fire-right-video"
					class={joinClasses(s.fireRight, showFireFlower && s.active)}
					src={`${videoRoot}/down/fire-left.webm`}
					ref={$ref => this.$fireRightVideo = $ref}
					muted
					playsInline
					preload="auto"
					onEnded={this.onEffectEnded}
				/>
				<video
					id="slot-yoshi-egg-video"
					class={joinClasses(s.yoshiEgg, showYoshiEgg && s.active)}
					src={yoshiEggVideoSrc}
					ref={$ref => this.$yoshiEggVideo = $ref}
					playsInline
					preload="auto"
					onEnded={this.onEffectEnded}
				/>
				<video
					id="slot-super-bell-video"
					class={joinClasses(s.superBell, showSuperBell && s.active)}
					ref={$ref => this.$superBellVideo = $ref}
					playsInline
					preload="auto"
					onEnded={this.onEffectEnded}
					poster={`${imageRoot}/down/super-bell-poster.webp`}
				>
					<source src={`${videoRoot}/down/super-bell.mov`} type={'video/mp4; codecs="hvc1"'} />
					<source src={`${videoRoot}/down/super-bell.webm`} type={'video/webm; codecs="vp9"'} />
				</video>
			</div>
		);
	}
}